module.exports = __webpack_public_path__ + "img/Macellaio-AS-013.6c956815.jpg";